import { ResponseError } from '../../errors';
import { prepareRecommendations } from '../../mappers';
import {
  fetchDesktopGetRecommendations,
  TDesktopGetRecommendationsResponse,
  IDesktopGetRecommendationsRequest,
} from '../../repositories/feed-page/v2/desktop/get-recommendations';
import { IApplicationContext } from '../../types/applicationContext';
import { TRecommendationsResult } from './types';

const DEGRADATION_TELEMETRY_KEY = 'degradation.recommendations.desktop';

type TGetRecommendationsParams = {
  parameters: IDesktopGetRecommendationsRequest;
  offset?: number;
  cookies?: string;
};

export async function getDesktopRecommendations(
  context: IApplicationContext,
  { parameters, offset = 0, cookies }: TGetRecommendationsParams,
): Promise<TRecommendationsResult> {
  const { httpApi, logger, telemetry } = context;

  try {
    const response: TDesktopGetRecommendationsResponse = await fetchDesktopGetRecommendations({
      httpApi,
      parameters,
      config: {
        requestConfig: {
          headers: cookies ? [['Cookie', cookies]] : [],
        },
      },
    });

    if (response.statusCode !== 200) {
      throw new ResponseError({
        domain: 'getDesktopRecommendations',
        message: response.response.message || 'Код ответа не 200',
        details: { errors: JSON.stringify(response.response.errors) },
      });
    }

    return {
      recommendations: prepareRecommendations(response.response.recommendations, offset),
      hasMore: !!response.response.hasMore,
      ...(response.response.totalCount !== undefined ? { totalCount: response.response.totalCount } : null),
    };
  } catch (error) {
    telemetry.increment(DEGRADATION_TELEMETRY_KEY);
    logger.warning(error, {
      domain: 'getDesktopRecommendations',
      message: 'Не удалось получить список рекомендаций',
    });

    // Повторное выкидывание исключения нужно для asyncThunk
    throw error;
  }
}
